import { api } from './client';
import type { Booking, BookingDocument, BookingType } from '../types';

export interface ExtractedBookingData {
  type?:                 BookingType;
  title:                 string;
  date:                  string;
  endDate?:              string;
  startTime?:            string;
  endTime?:              string;
  venue?:                string;
  address?:              string;
  bookingRef?:           string;
  aiCreditsLeft:         number;
  premiumAiCreditsLeft:  number;
}

export const bookingsApi = {
  list: (tripId: string) =>
    api.get<Booking[]>(`/trips/${tripId}/bookings`).then(r => r.data),
  create: (tripId: string, data: Partial<Booking>) =>
    api.post<Booking>(`/trips/${tripId}/bookings`, data).then(r => r.data),
  update: (tripId: string, bookingId: string, data: Partial<Booking>) =>
    api.patch<Booking>(`/trips/${tripId}/bookings/${bookingId}`, data).then(r => r.data),
  delete: (tripId: string, bookingId: string) =>
    api.delete(`/trips/${tripId}/bookings/${bookingId}`),
  uploadDocument: (tripId: string, bookingId: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post<BookingDocument>(
      `/trips/${tripId}/bookings/${bookingId}/documents`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data);
  },
  deleteDocument: (tripId: string, bookingId: string, docId: string) =>
    api.delete(`/trips/${tripId}/bookings/${bookingId}/documents/${docId}`),
  extract: (tripId: string, files: File[]) => {
    const form = new FormData();
    files.forEach(file => form.append('files', file));
    return api.post<ExtractedBookingData>(
      `/trips/${tripId}/bookings/extract`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then(r => r.data);
  },
};
